module.exports = __webpack_public_path__ + "img/tebiemingxie_en.5195db9.png";